// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleLayout_root__3FA4A","article":"ArticleLayout_article__3Rzuy","articleEnd":"ArticleLayout_articleEnd__1Q1Li","endMatter":"ArticleLayout_endMatter__1NDlk"};